import { Calendar, MessageCircle, Sparkles, TrendingUp } from 'lucide-react';
import { LandingTemplate, type LandingData } from '../components/LandingTemplate';
import { LANDING_GUIDES } from '../lib/landingGuides';

const data: LandingData = {
  seo: {
    title: 'Programar publicaciones en Threads · Zettapost',
    description:
      'Programa publicaciones en Threads desde un único panel. Posiciónate temprano en la red más nueva de Meta. Prueba 3 días gratis.',
    canonical: 'https://zettapost.com/programar-threads',
  },
  hero: {
    eyebrow: 'Programar Threads',
    headlinePre: 'Programa Threads',
    headlineAccent: 'antes que tu competencia.',
    subhead:
      'Lanza tus posts de Threads en las horas que tu audiencia está activa. Construye tu posicionamiento en la red más nueva de Meta sin estar pendiente del feed.',
    bullets: [
      'Posts con imagen o vídeo',
      'API oficial de Meta',
      'Multi-cuenta',
      '3 días gratis',
    ],
  },
  why: {
    eyebrow: '¿Por qué Zettapost para Threads?',
    title: 'Construye en Threads desde el primer día.',
    subtitle:
      'Pensado para marcas, creadores y agencias que quieren ocupar espacio en Threads antes de que se llene — y sin que les explote la productividad.',
    items: [
      {
        Icon: Calendar,
        title: 'Programa cuando quieras',
        description:
          'Programa hora exacta o usa la cola semanal. Zettapost publica solo, también de noche y los fines de semana, mientras tú haces otra cosa.',
      },
      {
        Icon: MessageCircle,
        title: 'Junto a Instagram',
        description:
          'Programa Threads en el mismo calendario que Instagram y el resto de tus redes, con un texto adaptado a cada una y vista previa antes de publicar.',
      },
      {
        Icon: Sparkles,
        title: 'IA que escribe por ti',
        description:
          'Sube una idea o el contexto y la IA te genera el post con el gancho adecuado, listo para publicar. Tono Threads, ni demasiado serio ni demasiado X.',
      },
      {
        Icon: TrendingUp,
        title: 'Aprovecha el momentum',
        description:
          'Threads sigue creciendo. Publicar consistentemente ahora te da posicionamiento desproporcionado: programa una semana de contenido en una sentada.',
      },
    ],
  },
  guide: LANDING_GUIDES.threads,
  faqs: [
    {
      q: '¿Qué necesito para conectar Threads?',
      a: 'Necesitas una cuenta de Instagram vinculada a tu Threads (la propia red lo requiere). Conectamos vía la API oficial de Meta para Threads, igual que con Instagram.',
    },
    {
      q: '¿Puedo programar hilos completos?',
      a: 'Todavía no. Zettapost programa publicaciones sueltas de hasta 500 caracteres, con imagen o vídeo; los hilos, de momento, se publican desde la app de Threads.',
    },
    {
      q: '¿Soporta imágenes y vídeo?',
      a: 'Sí. Puedes adjuntar imagen o vídeo a cada post de Threads, igual que en la app oficial. El editor te indica los límites de tamaño y formato.',
    },
    {
      q: '¿Puedo conectar varias cuentas de Threads?',
      a: 'Sí. Los planes con varias cuentas permiten gestionar Threads de varios clientes o marcas desde un mismo panel.',
    },
    {
      q: '¿Funciona con la API oficial de Threads?',
      a: 'Sí. Conectamos a través de la API oficial de Meta para Threads. Eso significa que tus publicaciones son nativas, sin penalización de alcance.',
    },
    {
      q: '¿Puedo cross-postear de Instagram a Threads?',
      a: 'Sí. Desde el mismo editor seleccionas las dos redes y se publica en cada una con su copy. Threads e Instagram son independientes para nosotros — adaptas el mensaje a cada audiencia.',
    },
  ],
  finalCta: {
    title: 'Posiciónate en Threads',
    titleAccent: 'mientras la competencia duda.',
    description: 'Crea tu cuenta y conecta Threads gratis durante 3 días.',
  },
  related: [
    { to: '/programar-instagram', label: 'Programar Instagram' },
    { to: '/programar-x', label: 'Programar X' },
    { to: '/precios', label: 'Ver precios' },
    { to: '/blog', label: 'Blog' },
  ],
};

export function ProgramarThreads() {
  return <LandingTemplate data={data} />;
}
